"use client";

import React from "react";
import {Stack, Box, Typography, alpha} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import MenuIcon from "@mui/icons-material/Menu";
import { useTranslations } from "next-intl";
import { Company } from "@/types/contentful/company";
import { NavigationType } from "@/components/header/common/header-enums";
import { Locale } from "@/i18n/routing";
import ColletteLogo from "@/components/collette-logo/collette-logo";


type MobileNavbarProps = {
  currentCompany?: Company;
  setActiveNavigation: (activeNavigation: NavigationType) => void;
  locale: Locale;
};

export default function MobileNavbar(props: MobileNavbarProps) {
  const { currentCompany, setActiveNavigation, locale } = props;
  const t = useTranslations("COMMON");
  return (
    <Stack>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          height: 75,
          backgroundColor: "var(--isagent-background-color)"
        }}
      >
        <Box
          sx={{
            flexDirection: "row",
            pt: 1
          }}
        >
          <Typography
            sx={{
              pl: 2,
              fontSize: "1.6rem",
              fontWeight: "500",
              textAlign: "center",
              color: "var(--isagent-text-color)"
            }}
          >
            {t("MENU")}
          </Typography>
          <Box
            sx={{
              pl: 3,
              width: 45,
              height: 35
            }}
            onClick={() => { setActiveNavigation(NavigationType.primary); }}
          >
            <MenuIcon
              sx={{
                color: "var(--isagent-text-color)",
                fontSize: 37,
                cursor: "pointer"
              }}
            />
          </Box>
        </Box>
        <Box
          sx={{
            pt: 3,
            filter:"var(--isagent-mobile-logo-color)"
          }}
        >
          <ColletteLogo
            company={currentCompany}
            logoType="headerLogo"
            fallbackurl="/images/collette-header-logo.png"
            height={25}
            width={130}
            locale={locale}
          />
        </Box>
        <Box
          sx={{
            pt: 2,
            pr: 2
          }}
        >
          <Box
            sx={{
              width: 45,
              height: 35,
              border: 1,
              borderColor: (theme) => alpha(theme.palette.common.white, 0.2),
              borderRadius: 18
            }}
            onClick={() => { setActiveNavigation(NavigationType.primary); }}
          >
            <SearchIcon
              sx={{
                ml: .5,
                color: "var(--isagent-text-color)",
                fontSize: 33
              }}
            />
          </Box>
        </Box>
      </Box>
    </Stack >
  );
}
